import { ref, computed } from 'vue'
import zxcvbn from 'zxcvbn'

export interface PasswordStrengthResult {
  score: number
  strengthText: string
  strengthColor: string
  strengthClass: string
  feedback: {
    warning: string
    suggestions: string[]
  }
  crackTime: string
}

export function usePasswordStrength() {
  const password = ref('')

  const result = computed<PasswordStrengthResult>(() => {
    if (!password.value) {
      return {
        score: 0,
        strengthText: '',
        strengthColor: '#e0e0e0',
        strengthClass: '',
        feedback: { warning: '', suggestions: [] },
        crackTime: ''
      }
    }

    const evaluation = zxcvbn(password.value)
    const score = evaluation.score

    const texts = ['极弱', '弱', '一般', '强', '极强']
    const colors = ['#ff4d4f', '#ff7875', '#ffa940', '#73d13d', '#52c41a']
    const classes = ['very-weak', 'weak', 'fair', 'strong', 'very-strong']

    // 计算破解时间描述
    let crackTime = ''
    const seconds = Number(evaluation.crack_times_seconds.online_no_throttling_10_per_second)
    if (seconds < 60) {
      crackTime = '瞬间'
    } else if (seconds < 3600) {
      crackTime = Math.round(seconds / 60) + ' 分钟'
    } else if (seconds < 86400) {
      crackTime = Math.round(seconds / 3600) + ' 小时'
    } else if (seconds < 31536000) {
      crackTime = Math.round(seconds / 86400) + ' 天'
    } else if (seconds < 3153600000) {
      crackTime = Math.round(seconds / 31536000) + ' 年'
    } else {
      crackTime = '数世纪'
    }

    return {
      score,
      strengthText: texts[score],
      strengthColor: colors[score],
      strengthClass: classes[score],
      feedback: evaluation.feedback,
      crackTime
    }
  })

  const isStrongEnough = computed(() => result.value.score >= 2)

  return {
    password,
    result,
    isStrongEnough
  }
}
